var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#95BF47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2926 22.9109L24.2517 16.9625L24.2007 16.9952C24.546 16.7932 24.7622 16.415 24.7622 16.0002L24.7569 15.8881C24.7253 15.5551 24.5543 15.2551 24.2916 15.0645L24.2517 15.0387L18.2926 9.08949L18.2069 9.01287C17.7518 8.65838 17.1233 8.68753 16.7204 9.07212L16.6421 9.1549C16.276 9.58364 16.2944 10.225 16.7026 10.6326L20.9329 14.8573L8.34435 14.8573L8.23674 14.8632C7.65602 14.9333 7.2384 15.4229 7.2384 16.0002L7.24342 16.1096C7.29657 16.6862 7.76538 17.143 8.34435 17.143H20.9352L16.7026 21.3677L16.626 21.4533C16.2679 21.9123 16.3129 22.5392 16.7204 22.9282C17.1604 23.3483 17.8623 23.3406 18.2926 22.9109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreen);
export default __webpack_public_path__ + "static/media/arrow-right-green.e5abc5c9158ad0867720d42de279be8f.svg";
export { ForwardRef as ReactComponent };